<template>
  <div
    :class="['form__input', { 'form__input--small': small, 'disabled': disabled }]"
  >
    <h5
      v-if="title"
      class="info_title form__input__title"
      :class="{'info_title--small': titleGrey}"
    >
      {{ title }}:
    </h5>
    <div class="form__input__field_wrapper">
      <input
        ref="inputRef"
        :value="modelValue"
        class="form__input__field_text"
        type="text"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="updateInput"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 't-input',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    titleGrey: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    updateInput(event) {
      const { value } = event.target
      let trimmedValue = value
      if (this.maxlength && trimmedValue.length > this.maxlength) {
        trimmedValue = trimmedValue.slice(0, this.maxlength)
      }
      this.$emit('update:modelValue', trimmedValue)
    },
    focusInput() {
      this.$refs.inputRef.focus()
    },
  },
}
</script>
